/**
 * Workspace Discovery and Join Request Types
 * For PRD Phase 4.3 - Workspace Discovery System
 */

export enum WorkspaceType {
  OPEN = 'open',
  CLOSED = 'closed',
  HIDDEN = 'hidden',
}

export enum JoinRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

// ==================== Workspace Discovery ====================

export interface DiscoverableWorkspace {
  id: string;
  name: string;
  description: string | null;
  type: WorkspaceType;
  owner: {
    id: string;
    name: string;
    email: string;
  };
  memberCount: number;
  createdAt: string;
  canJoin: boolean; // true for OPEN workspaces
  canRequest: boolean; // true for CLOSED workspaces
  hasPendingRequest: boolean; // true if user has pending join request
}

export interface DiscoverWorkspacesResponse {
  workspaces: DiscoverableWorkspace[];
  total: number;
  hasMore: boolean;
}

export interface DiscoverWorkspacesRequest {
  search?: string;
  type?: WorkspaceType;
  limit?: number;
  offset?: number;
}

// ==================== Join Requests ====================

export interface WorkspaceJoinRequest {
  id: string;
  workspaceId: string;
  userId: string;
  message: string | null;
  status: JoinRequestStatus;
  requestedAt: string;
  respondedAt: string | null;
  respondedBy: string | null;
  user?: {
    id: string;
    name: string;
    email: string;
  };
  workspace?: {
    id: string;
    name: string;
    type: WorkspaceType;
  };
  responder?: {
    id: string;
    name: string;
  } | null;
}

export interface SubmitJoinRequestRequest {
  message?: string;
}

export interface SubmitJoinRequestResponse {
  message: string;
  joinRequest: WorkspaceJoinRequest;
}

export interface JoinWorkspaceResponse {
  message: string;
  member: {
    id: string;
    workspaceId: string;
    userId: string;
    role: string;
  };
}

export interface ApproveJoinRequestResponse {
  message: string;
  joinRequest: WorkspaceJoinRequest;
  member: {
    id: string;
    workspaceId: string;
    userId: string;
    role: string;
  };
}

export interface RejectJoinRequestResponse {
  message: string;
  joinRequest: WorkspaceJoinRequest;
}

export interface JoinRequestQueryParams {
  status?: JoinRequestStatus;
}
